import { RECEIVER as CONFIG_RECEIVER, USDC_BASE as CONFIG_USDC } from './lib/config';

export const RECEIVER  = CONFIG_RECEIVER;
export const USDC_BASE = CONFIG_USDC;
export const BASE_HEX  = '0x2105';

export const PRICE = {
  ETH_WEI_PER_UNIT: 5_000_000_000_000_000n, // 0.005 ETH
  USDC_PER_UNIT:    15_000_000n,            // 15 USDC (6 decimais)
};

const toHex = (n: bigint) => '0x' + n.toString(16);
const pad32 = (hex: string) => hex.replace(/^0x/,'').padStart(64,'0');
const SELECTOR_TRANSFER = '0xa9059cbb';

export const erc20Data = (to: string, amt: bigint) =>
  SELECTOR_TRANSFER + pad32(to) + pad32(toHex(amt));
